(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-showcase"] && !Shopify.designMode) return;
  try {
    
  function initWwPair(scope) {
    (scope || document).querySelectorAll('[data-wwpair-scroll]').forEach(function (a) {
      if (a.dataset.b) return; a.dataset.b = '1';
      a.addEventListener('click', function (e) {
        if (a.getAttribute('data-wwpair-scroll')) return; // real link, let it navigate
        e.preventDefault();
        var t = document.querySelector('.winwear-main-product');
        if (!t) return;
        var y = t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 70;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWwPair(); });
  document.addEventListener('shopify:section:load', function (e) { initWwPair(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-your-fit"] && !Shopify.designMode) return;
  try {
    
  class WinwearFit {
    constructor(root) {
      this.root = root;
      this.h = root.querySelector('[data-fit-height]');
      this.w = root.querySelector('[data-fit-weight]');
      this.hv = root.querySelector('[data-fit-height-val]');
      this.wv = root.querySelector('[data-fit-weight-val]');
      this.out = root.querySelector('[data-fit-size]');
      this.noteEl = root.querySelector('[data-fit-note]');
      this.toggles = Array.from(root.querySelectorAll('[data-fit-toggle]'));
      this.rows = Array.from(root.querySelectorAll('[data-fit-row]'));
      this.sizes = this.rows.map(function (r) { return r.getAttribute('data-fit-row'); });
      this.fit = 'regular';
      this.notes = { slim: 'Tailored, closer to the body.', regular: 'Classic everyday fit.', oversized: 'Roomy, relaxed streetwear fit.' };
      if (!this.h || !this.w) return;
      const self = this;
      this.toggles.forEach(function (b) {
        b.addEventListener('click', function () { self.fit = b.getAttribute('data-fit-toggle'); self.update(); });
      });
      this.h.addEventListener('input', function () { self.update(); });
      this.w.addEventListener('input', function () { self.update(); });
      this.useBtn = root.querySelector('[data-fit-use]');
      this.useSizeEl = root.querySelector('[data-fit-use-size]');
      if (this.useBtn) this.useBtn.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('winwear:usesize', { detail: { size: self.out ? self.out.textContent : '' } }));
        var t = document.querySelector('.winwear-main-product');
        if (t) window.scrollTo({ top: t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 70, behavior: 'smooth' });
      });
      this.update();
    }
    update() {
      const h = parseInt(this.h.value, 10);
      const w = parseInt(this.w.value, 10);
      const hMin = parseInt(this.h.min, 10) || 150;
      const wMin = parseInt(this.w.min, 10) || 45;
      if (this.hv) this.hv.textContent = h + ' cm';
      if (this.wv) this.wv.textContent = w + ' kg';
      let score = (w - wMin) / 10 + (h - hMin) / 14;
      let idx = Math.round(score / 2);
      if (this.fit === 'slim') idx -= 1;
      if (this.fit === 'oversized') idx += 1;
      const len = this.sizes.length || 1;
      idx = Math.max(0, Math.min(len - 1, idx));
      const size = this.sizes[idx];
      if (this.out) this.out.textContent = size || '—';
      if (this.useSizeEl) this.useSizeEl.textContent = size || '—';
      if (this.noteEl) this.noteEl.textContent = this.notes[this.fit];
      const self = this;
      this.rows.forEach(function (r) { r.setAttribute('data-active', r.getAttribute('data-fit-row') === size ? 'true' : 'false'); });
      this.toggles.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-fit-toggle') === self.fit ? 'true' : 'false'); });
    }
  }
  function initWinwearFit(scope) {
    (scope || document).querySelectorAll('[data-winwear-fit]').forEach(function (el) {
      if (!el.dataset.wfInit) { el.dataset.wfInit = '1'; new WinwearFit(el); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWinwearFit(); });
  document.addEventListener('shopify:section:load', function (e) { initWinwearFit(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class WinwearHero {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      this.index = 0;
      this.autoplay = root.dataset.autoplay === 'true';
      this.speed = parseInt(root.dataset.speed, 10) || 5000;
      this.timer = null;
      if (this.slides.length <= 1) return;
      const prev = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      this.start();
    }
    go(n, fromUser) {
      const len = this.slides.length;
      this.index = ((n % len) + len) % len;
      this.slides.forEach((slide, i) => {
        slide.style.opacity = i === this.index ? '1' : '0';
        slide.style.zIndex = i === this.index ? '1' : '0';
      });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      if (fromUser) this.start();
    }
    start() { if (!this.autoplay) return; this.stop(); this.timer = setInterval(() => this.go(this.index + 1), this.speed); }
    stop() { clearInterval(this.timer); }
  }
  function initWinwearHeroes(scope) {
    (scope || document).querySelectorAll('[data-winwear-hero]').forEach(function (el) {
      if (!el.dataset.whInit) { el.dataset.whInit = '1'; new WinwearHero(el); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWinwearHeroes(); });
  document.addEventListener('shopify:section:load', function (e) { initWinwearHeroes(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function(){
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function change(key, qty){
    return fetch(ROOT+'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(){ window.location.reload(); });
  }
  function add(id){
    return fetch(ROOT+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(){ window.location.reload(); });
  }
  function boot(){
    var sec = document.querySelector('.wwcp'); if(!sec || sec.__wwcp) return; sec.__wwcp = true;
    sec.addEventListener('click', function(e){
      var row = e.target.closest('.wwcp__item');
      var inc = e.target.closest('[data-cp-inc]'), dec = e.target.closest('[data-cp-dec]'), rm = e.target.closest('[data-cp-remove]'), ad = e.target.closest('[data-cp-add]');
      if((inc||dec) && row){ var cur = parseInt(row.querySelector('.wwcp__qty span').textContent,10)||0; change(row.getAttribute('data-key'), Math.max(0, cur+(inc?1:-1))); }
      else if(rm && row){ change(row.getAttribute('data-key'), 0); }
      else if(ad){ e.preventDefault(); add(ad.getAttribute('data-cp-add')); }
    });
  }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  function initWwq(scope) {
    (scope || document).querySelectorAll('[data-wwq]').forEach(function (q) {
      if (q.dataset.b) return; q.dataset.b = '1';
      q.addEventListener('click', function () {
        var body = q.nextElementSibling;
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        q.querySelector('.wwq__sign').textContent = open ? '+' : '\u2013';
        body.style.maxHeight = open ? '0' : (body.firstElementChild.offsetHeight + 4) + 'px';
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWwq(); });
  document.addEventListener('shopify:section:load', function (e) { initWwq(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fit"] && !Shopify.designMode) return;
  try {
    
  function initWwFit2(scope) {
    (scope || document).querySelectorAll('[data-wwfit2-scroll]').forEach(function (btn) {
      if (btn.dataset.b) return; btn.dataset.b = '1';
      btn.addEventListener('click', function () {
        var t = document.querySelector('.winwear-fit-section') || document.querySelector('.winwear-main-product');
        if (!t) return;
        var y = t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWwFit2(); });
  document.addEventListener('shopify:section:load', function (e) { initWwFit2(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // Hand the homepage over to Judge.me only once its carousel really has
  // reviews in it. Judge.me injects asynchronously and leaves the wrapper
  // empty when there is nothing to show, so "the element exists" is not a
  // good enough signal — we wait for actual review nodes.
  (function () {
    function hasReviews(wrap) {
      return !!wrap.querySelector('.jdgm-carousel-item, .jdgm-rev, .jdgm-carousel__item');
    }
    function sync(scope) {
      (scope || document).querySelectorAll('[data-ww-jm-carousel]').forEach(function (wrap) {
        var section = wrap.closest('.winwear-reviews');
        var curated = section && section.querySelector('[data-ww-curated]');
        if (!curated) return;
        function apply() {
          var live = hasReviews(wrap);
          curated.hidden = live;
          wrap.hidden = !live;
        }
        apply();
        if (wrap.__wwObs) return;
        wrap.__wwObs = new MutationObserver(apply);
        wrap.__wwObs.observe(wrap, { childList: true, subtree: true });
      });
    }
    if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', function () { sync(); });
    document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(el){
    if(!el || el.__wwsg) return; el.__wwsg = true;
    function open(){ el.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
    function close(){ el.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
    function showPane(name){
      el.querySelectorAll('[data-wwsg-panel]').forEach(function(p){
        var on = p.getAttribute('data-wwsg-panel') === name;
        if(on) p.removeAttribute('hidden'); else p.setAttribute('hidden','');
      });
      el.querySelectorAll('[data-wwsg-tab]').forEach(function(t){
        var on = t.getAttribute('data-wwsg-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    el.addEventListener('click', function(e){
      if(e.target.closest('[data-wwsg-close]')) close();
      var tab = e.target.closest('[data-wwsg-tab]');
      if(tab) showPane(tab.getAttribute('data-wwsg-tab'));
      var f = e.target.closest('[data-wwsg-finder]');
      if(f){ close(); var sel = f.getAttribute('data-wwsg-finder') || '#find-your-fit'; var t = document.querySelector(sel); if(t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' }); }
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && el.getAttribute('aria-hidden')==='false') close(); });
    document.addEventListener('click', function(e){ if(e.target.closest('[data-size-guide], [data-size-guide-open]')){ e.preventDefault(); open(); } });
    window.wwSizeGuide = { open: open, close: close };
  }
  function boot(){ document.querySelectorAll('size-guide.wwsg').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending"] && !Shopify.designMode) return;
  try {
    
  (function(){
    // Guard: this section's JS is re-run by the theme editor on shopify:section:load.
    // Bind the document click listener only once so a card isn't added twice.
    if (window.__wwTrendingAddBound) return;
    window.__wwTrendingAddBound = true;

    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    document.addEventListener('click', function(e){
      var t = e.target.closest('[data-ww-add]');
      if (!t) return;
      var id = t.getAttribute('data-ww-add');
      if (!id) return;
      e.preventDefault();
      var fallback = t.getAttribute('href') || (ROOT + 'cart');
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function(r){ return r.json(); })
      .then(function(res){
        // Shopify returns a `status` key only on errors (e.g. sold out) — fall back to the PDP.
        if (res && res.status) { window.location = fallback; return; }
        if (window.wwCartDrawer && window.wwCartDrawer.open) { window.wwCartDrawer.open(); }
        else { window.location = ROOT + 'cart'; }
      })
      .catch(function(){ window.location = fallback; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winwear-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.__wwcd) return; root.__wwcd = true;
    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    // Fallback money format, resolving to a dollar sign + the Shopify amount placeholder.
    // Escaped: Liquid parses a literal double-brace even inside a javascript tag,
    // which makes the whole section fail to upload.
    var fmt = root.getAttribute('data-money-format') || '$\u007B\u007Bamount\u007D\u007D';
    var threshold = parseInt(root.getAttribute('data-free-ship') || '0', 10) || 0;
    var itemsEl = root.querySelector('[data-wwcd-items]');
    var emptyEl = root.querySelector('[data-wwcd-empty]');
    var crossEl = root.querySelector('[data-wwcd-cross]');
    var footEl  = root.querySelector('[data-wwcd-foot]');

    function money(cents){
      var n = (cents/100), parts = n.toFixed(2).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      var withDec = dollars + '.' + parts[1];
      var noDec = dollars;
      var out = fmt;
      if(/amount_no_decimals/.test(fmt)) out = fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec);
      else out = fmt.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, withDec);
      return out.replace(/<[^>]+>/g,'');
    }
    // The wwcd-open class on <html> lets other sections react — the PDP sticky add-to-cart
    // bar hides itself while the drawer is up instead of sitting on top of it.
    function open(){ root.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; document.documentElement.classList.add('wwcd-open'); }
    function close(){ root.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; document.documentElement.classList.remove('wwcd-open'); }

    function updateShip(total){
      var ship = root.querySelector('[data-wwcd-ship]');
      if(!ship) return;
      if(threshold <= 0){ ship.hidden = true; return; }
      ship.hidden = false;
      var remain = Math.max(0, threshold - total), pct = Math.min(100, total / threshold * 100);
      var msg = root.querySelector('[data-wwcd-ship-msg]'), fill = root.querySelector('[data-wwcd-ship-fill]');
      if(remain <= 0){ msg.innerHTML = "You've unlocked <b>FREE shipping!</b>"; ship.classList.add('is-unlocked'); }
      else { msg.innerHTML = "You're <b>" + money(remain) + "</b> away from <b>FREE shipping</b>"; ship.classList.remove('is-unlocked'); }
      fill.style.width = pct + '%';
    }
    function lineHtml(it){
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2') : '';
      return '<div class="wwcd__item" data-key="'+it.key+'">'
        + '<a href="'+it.url+'" class="wwcd__item-media">'+(img?'<img src="'+img+'" alt="" class="wwcd__item-img">':'')+'</a>'
        + '<div class="wwcd__item-main"><div class="wwcd__item-top">'
        + '<a href="'+it.url+'" class="wwcd__item-name">'+it.product_title+'</a>'
        + '<button class="wwcd__item-rm" type="button" data-wwcd-remove="'+it.key+'">Remove</button></div>'
        + (variant ? '<div class="wwcd__item-var">'+variant+'</div>' : '')
        + '<div class="wwcd__item-bot"><div class="wwcd__qty">'
        + '<button type="button" data-wwcd-dec="'+it.key+'">&minus;</button><span>'+it.quantity+'</span>'
        + '<button type="button" data-wwcd-inc="'+it.key+'">+</button></div>'
        + '<div class="wwcd__item-price">'+money(it.final_line_price)+'</div></div></div></div>';
    }
    function render(cart){
      root.querySelectorAll('[data-wwcd-count]').forEach(function(e){ e.textContent = '(' + cart.item_count + ')'; });
      document.querySelectorAll('[data-cart-count]').forEach(function(e){ e.setAttribute('data-cart-count', cart.item_count); });
      updateShip(cart.total_price);
      if(cart.item_count === 0){
        if(emptyEl) emptyEl.hidden = false;
        if(itemsEl) itemsEl.innerHTML = '';
        if(crossEl) crossEl.style.display = 'none';
        if(footEl) footEl.style.display = 'none';
      } else {
        if(emptyEl) emptyEl.hidden = true;
        if(crossEl) crossEl.style.display = '';
        if(footEl) footEl.style.display = '';
        if(itemsEl) itemsEl.innerHTML = cart.items.map(lineHtml).join('');
      }
      root.querySelectorAll('[data-wwcd-sub]').forEach(function(e){ e.textContent = money(cart.total_price); });
      var cl = root.querySelector('[data-wwcd-checkout-label]');
      if(cl) cl.textContent = cart.item_count ? ('Checkout · ' + money(cart.total_price)) : 'Checkout';
    }
    function refresh(){ return fetch(ROOT+'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(render); }
    function change(key, qty){ return fetch(ROOT+'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render); }
    function add(id, qty){ return fetch(ROOT+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})}).then(function(r){return r.json();}).then(refresh).then(open); }

    root.addEventListener('click', function(e){
      if(e.target.closest('[data-wwcd-close]')){ close(); return; }
      var inc=e.target.closest('[data-wwcd-inc]'), dec=e.target.closest('[data-wwcd-dec]'), rm=e.target.closest('[data-wwcd-remove]'), ad=e.target.closest('[data-wwcd-add]');
      var line=e.target.closest('.wwcd__item');
      if((inc||dec) && line){ var cur=parseInt(line.querySelector('.wwcd__qty span').textContent,10)||0; var key=(inc||dec).getAttribute(inc?'data-wwcd-inc':'data-wwcd-dec'); change(key, Math.max(0, cur+(inc?1:-1))); }
      else if(rm){ change(rm.getAttribute('data-wwcd-remove'), 0); }
      else if(ad){ add(ad.getAttribute('data-wwcd-add'), 1); }
      else if(e.target.closest('[data-wwcd-promo-toggle]')){ var p=root.querySelector('[data-wwcd-promo]'); if(p) p.hidden=!p.hidden; }
    });

    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && root.getAttribute('aria-hidden')==='false') close(); });
    document.addEventListener('click', function(e){
      var trg = e.target.closest('[data-cart-drawer-open], .winwear-header__icon--cart, a[href$="/cart"]');
      if(trg && !trg.closest('.wwcd')){ e.preventDefault(); refresh().then(open); }
    });
    // Capture phase: Dawn's product-form.js binds its own submit listener on the form and
    // would add the item a second time. Stopping propagation here makes the drawer the only
    // add-to-cart path, on both the Winwear PDP and the stock Dawn product pages.
    document.addEventListener('submit', function(e){
      var f = e.target;
      if(f && f.matches && f.matches('form#wwp-form, form[action*="/cart/add"]')){
        e.preventDefault();
        e.stopPropagation();
        fetch(ROOT+'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(f)})
          .then(function(r){return r.json();})
          .then(function(res){
            if(res && res.status){ if(typeof window.alert === 'function' && res.description) window.alert(res.description); return; }
            refresh().then(open);
          })
          .catch(function(){ f.submit(); });
      }
    }, true);

    refresh();
    window.wwCartDrawer = { open: function(){ refresh().then(open); }, close: close, refresh: refresh };
  }
  function boot(){ document.querySelectorAll('winwear-cart-drawer.wwcd').forEach(init); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winwear-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  // <details> stays open until it is told otherwise, so close the desktop dropdown on an
  // outside click or Escape — otherwise the panel covers the page after you navigate away.
  function closeAll(except) {
    document.querySelectorAll('[data-winwear-dd][open]').forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (e) {
    var dd = e.target.closest ? e.target.closest('[data-winwear-dd]') : null;
    closeAll(dd);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // Hover-open, but only where hovering is a real input and only on the desktop nav —
  // on touch the summary click drives it, so we would otherwise open on the first tap.
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var closeTimer;
  document.querySelectorAll('[data-winwear-dd]').forEach(function (dd) {
    dd.addEventListener('mouseenter', function () {
      if (!hoverable.matches) return;
      clearTimeout(closeTimer);
      closeAll(dd);
      dd.setAttribute('open', '');
    });
    dd.addEventListener('mouseleave', function () {
      if (!hoverable.matches) return;
      // Small grace period so a diagonal mouse path to the panel does not close it.
      closeTimer = setTimeout(function () { dd.removeAttribute('open'); }, 180);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winwear-main-product"] && !Shopify.designMode) return;
  try {
    
  class WinwearProduct {
    constructor(root) {
      this.root = root;
      const dataEl = root.querySelector('[data-wwp-variants]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent || '[]') : [];
      this.colorPos = parseInt(root.getAttribute('data-color-pos'), 10) || 0;
      this.sizePos = parseInt(root.getAttribute('data-size-pos'), 10) || 0;
      // Fallback money format, resolving to a dollar sign + the Shopify amount placeholder.
      // Escaped: Liquid parses a literal double-brace even inside a javascript tag,
      // which makes the whole section fail to upload.
      this.moneyFmt = root.getAttribute('data-money-format') || '$\u007B\u007Bamount\u007D\u007D';
      this.idInput = root.querySelector('[data-wwp-id]');
      this.form = root.querySelector('.wwp__form');
      this.current = this.variantById(this.idInput ? this.idInput.value : null) || this.variants[0];
      this.selected = { color: null, size: null };
      if (this.current) {
        if (this.colorPos) this.selected.color = this.current.options[this.colorPos - 1];
        if (this.sizePos) this.selected.size = this.current.options[this.sizePos - 1];
      }
      // Seed from whichever tier renders active, so the CTA and the quantity
      // agree with the highlighted row before anyone clicks.
      var firstTier = root.querySelector('[data-wwp-bundle].is-active') || root.querySelector('[data-wwp-bundle]');
      this.bundle = firstTier
        ? { qty: parseInt(firstTier.getAttribute('data-qty'), 10) || 1, discount: parseFloat(firstTier.getAttribute('data-discount')) || 0 }
        : { qty: 1, discount: 0 };
      var qtyInput = root.querySelector('[data-wwp-qty]');
      if (qtyInput) qtyInput.value = this.bundle.qty;
      this.bind();
      this.paintSwatches();
      this.refreshSizeAvailability();
      this.update(true);
    }
    variantById(id) { id = String(id); return this.variants.find(function (v) { return String(v.id) === id; }); }
    // What the shopper actually pays for the selected tier, in cents. Mirrors the
    // Shopify automatic discount — if that changes, the tier percentages must too.
    tierNet(v) {
      if (!v) return 0;
      var qty = (this.bundle && this.bundle.qty) || 1;
      var pct = (this.bundle && this.bundle.discount) || 0;
      return Math.round(v.price * qty * (100 - pct) / 100);
    }
    money(cents) {
      var amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return this.moneyFmt.replace(/\{\{\s*amount\s*\}\}/g, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }
    matchVariant() {
      var self = this;
      return this.variants.find(function (v) {
        var okC = !self.colorPos || v.options[self.colorPos - 1] === self.selected.color;
        var okS = !self.sizePos || v.options[self.sizePos - 1] === self.selected.size;
        return okC && okS;
      });
    }
    firstInColor(color) {
      var self = this;
      return this.variants.find(function (v) {
        return (!self.colorPos || v.options[self.colorPos - 1] === color) && v.available;
      }) || this.variants.find(function (v) { return !self.colorPos || v.options[self.colorPos - 1] === color; });
    }
    bind() {
      var self = this;
      this.root.querySelectorAll('[data-wwp-choice]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pos = parseInt(btn.getAttribute('data-pos'), 10);
          var val = btn.getAttribute('data-value');
          if (pos === self.colorPos) {
            self.selected.color = val;
            var fv = self.firstInColor(val);
            if (fv && self.sizePos) {
              var s = fv.options[self.sizePos - 1];
              var stillOk = self.variants.some(function (v) { return v.options[self.colorPos - 1] === val && v.options[self.sizePos - 1] === self.selected.size && v.available; });
              if (!stillOk) self.selected.size = s;
            }
          } else if (pos === self.sizePos) {
            self.selected.size = val;
            self.needSize = false;
          } else {
            self.selected['opt' + pos] = val;
          }
          self.refreshSizeAvailability();
          self.update();
        });
      });
      this.root.querySelectorAll('[data-wwp-thumb]').forEach(function (t) {
        t.addEventListener('click', function () { self.setMain(t.getAttribute('data-full'), t); });
      });
      this.root.querySelectorAll('[data-wwp-bundle]').forEach(function (b) {
        b.addEventListener('click', function () {
          self.root.querySelectorAll('[data-wwp-bundle]').forEach(function (x) {
            x.classList.remove('is-active');
            x.setAttribute('aria-pressed', 'false');
          });
          b.classList.add('is-active');
          b.setAttribute('aria-pressed', 'true');
          self.bundle = {
            qty: parseInt(b.getAttribute('data-qty'), 10) || 1,
            discount: parseFloat(b.getAttribute('data-discount')) || 0
          };
          // The quantity is the only thing that reaches the cart; the discount is Shopify's.
          var qtyInput = self.root.querySelector('[data-wwp-qty]');
          if (qtyInput) qtyInput.value = self.bundle.qty;
          self.update();
        });
      });
      this.root.querySelectorAll('[data-wwp-acc]').forEach(function (q) {
        q.addEventListener('click', function () {
          var body = q.nextElementSibling;
          var open = q.getAttribute('aria-expanded') === 'true';
          q.setAttribute('aria-expanded', open ? 'false' : 'true');
          q.querySelector('.wwp__acc-sign').textContent = open ? '+' : '\u2013';
          body.style.maxHeight = open ? '0' : (body.firstElementChild.offsetHeight + 4) + 'px';
        });
      });
      this.root.querySelectorAll('[data-wwp-scroll]').forEach(function (el) {
        el.addEventListener('click', function () { self.scrollTo(el.getAttribute('data-wwp-scroll')); });
      });
      // sticky
      this.sticky = this.root.querySelector('[data-wwp-sticky]');
      if (this.sticky) {
        var addBtn = this.sticky.querySelector('[data-wwp-sticky-add]');
        if (addBtn) addBtn.addEventListener('click', function () { self.submit(); });
        this._onScroll = function () {
          var show = (window.scrollY || window.pageYOffset || 0) > 620;
          self.sticky.hidden = !show;
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
      }
      // form submit guard: require size
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          if (self.sizePos && !self.selected.size) {
            e.preventDefault();
            self.needSize = true;
            var vals = self.root.querySelector('[data-wwp-opt="' + self.sizePos + '"] [data-wwp-values]');
            if (vals) { vals.classList.add('wwp--needsize'); setTimeout(function () { vals.classList.remove('wwp--needsize'); }, 1600); }
          }
        });
      }
      // find-your-fit → set size
      window.addEventListener('winwear:usesize', function (e) {
        var size = e.detail && e.detail.size;
        if (!size || !self.sizePos) return;
        var btn = self.root.querySelector('[data-wwp-choice][data-pos="' + self.sizePos + '"][data-value="' + size + '"]');
        if (btn) { btn.click(); self.scrollTo(null, self.root); }
      });
    }
    paintSwatches() {
      // Exact name wins; otherwise the first substring hit below wins, so key order matters:
      // compound names first, and 'navy'/'black' before 'white' so "Navy/ White" isn't read as white.
      var map = {
        'black heather': '#2b2b2d', 'heather olive': '#6b6a4a', 'dark heather gray': '#6e7275',
        'dark grey heather': '#6e7275', 'heather grey/white': '#b7babe', 'athletic heather': '#b7babe',
        'charcoal melange': '#36393d', 'black/ white': '#1a1a1a', 'navy/ white': '#1e2a44',
        'true royal': '#1f57b3', 'royal blue': '#1f57b3', 'bottle green': '#0f3b2e',
        'light blue': '#8fbce0', 'soft cream': '#efe9db', 'evergreen': '#20402e',
        'heather': '#b7babe', 'silver': '#c9cbcd', 'charcoal': '#36393d', 'cranberry': '#8c2b3f',
        'caramel': '#a9662f', 'khaki': '#bfae8a', 'asphalt': '#4a4e52', 'sage': '#9caa8d',
        'kelly': '#2e8b4a', 'olive': '#6b6a4a', 'cream': '#efe9db', 'tan': '#d2b48c',
        'red': '#b5322c', 'royal': '#1f57b3', 'navy': '#1e2a44', 'forest': '#20402e',
        'green': '#20402e', 'blue': '#1f57b3', 'black': '#1a1a1a', 'white': '#f4f4f2',
        'sand': '#d8c39a', 'gold': '#c79a4d', 'grey': '#8a8d90', 'gray': '#8a8d90'
      };
      this.root.querySelectorAll('.wwp__swatch').forEach(function (sw) {
        var name = (sw.getAttribute('data-color') || '').trim();
        var hex = map[name];
        if (!hex) { for (var k in map) { if (name.indexOf(k) > -1) { hex = map[k]; break; } } }
        if (hex) { sw.style.background = hex; if (name.indexOf('white') > -1) sw.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.12)'; }
      });
    }
    setMain(src, thumb) {
      var main = this.root.querySelector('[data-wwp-main]');
      if (main && src) main.src = src;
      this.root.querySelectorAll('[data-wwp-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
    }
    refreshSizeAvailability() {
      var self = this;
      if (!this.sizePos) return;
      this.root.querySelectorAll('[data-wwp-choice][data-pos="' + this.sizePos + '"]').forEach(function (btn) {
        var size = btn.getAttribute('data-value');
        var ok = self.variants.some(function (v) {
          var okC = !self.colorPos || v.options[self.colorPos - 1] === self.selected.color;
          return okC && v.options[self.sizePos - 1] === size && v.available;
        });
        btn.classList.toggle('is-soldout', !ok);
      });
    }
    scrollTo(sel, el) {
      var target = el || (sel ? document.querySelector(sel) : null);
      if (!target) return;
      var y = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    update(initial) {
      var self = this;
      // active states
      this.root.querySelectorAll('[data-wwp-choice]').forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-pos'), 10);
        var val = btn.getAttribute('data-value');
        var on = (pos === self.colorPos && val === self.selected.color) || (pos === self.sizePos && val === self.selected.size);
        btn.classList.toggle('is-active', on);
      });
      var colorLabel = this.root.querySelector('[data-wwp-color-label]');
      if (colorLabel && this.selected.color) colorLabel.textContent = this.selected.color;
      // matched variant
      var v = this.matchVariant();
      if (v) {
        this.current = v;
        if (this.idInput) this.idInput.value = v.id;
        var priceEl = this.root.querySelector('[data-wwp-price]');
        var compEl = this.root.querySelector('[data-wwp-compare]');
        var saveEl = this.root.querySelector('[data-wwp-save]');
        if (priceEl) priceEl.textContent = this.money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (compEl) { compEl.hidden = !onSale; if (onSale) compEl.textContent = this.money(v.compare_at_price); }
        if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF'; }
        // main image follows color
        if (v.featured_image && v.featured_image.src && !initial) {
          var main = this.root.querySelector('[data-wwp-main]');
          if (main) main.src = v.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_1000x$1');
        }
        var cap = this.root.querySelector('[data-wwp-caption]');
        if (cap) cap.textContent = v.title;
      }
      // CTA + sticky
      var avail = v ? v.available : false;
      var cta = this.root.querySelector('[data-wwp-cta]');
      var ctaTxt = this.root.querySelector('[data-wwp-cta-text]');
      if (cta) cta.disabled = !avail;
      if (ctaTxt) {
        if (!avail) ctaTxt.textContent = 'Sold out';
        else if (this.bundle && this.bundle.qty > 1) ctaTxt.textContent = 'Add ' + this.bundle.qty + ' to Cart — ' + this.money(this.tierNet(v));
        else ctaTxt.textContent = 'Add to Cart — ' + this.money(this.tierNet(v));
      }
      // Tier prices are per-variant, so they follow a colour/size change.
      if (v) {
        this.root.querySelectorAll('[data-wwp-bundle]').forEach(function (b) {
          var q = parseInt(b.getAttribute('data-qty'), 10) || 1;
          var d = parseFloat(b.getAttribute('data-discount')) || 0;
          var gross = v.price * q;
          var netEl = b.querySelector('[data-wwp-tier-net]');
          var grossEl = b.querySelector('[data-wwp-tier-gross]');
          if (netEl) netEl.textContent = self.money(Math.round(gross * (100 - d) / 100));
          if (grossEl) grossEl.textContent = self.money(gross);
        });
      }
      if (this.sticky && v) {
        var ss = this.sticky.querySelector('[data-wwp-sticky-sum]');
        var sp = this.sticky.querySelector('[data-wwp-sticky-price]');
        var si = this.sticky.querySelector('[data-wwp-sticky-img]');
        if (ss) ss.textContent = (this.selected.color || '') + (this.selected.size ? ' · ' + this.selected.size : ' · Select size');
        if (sp) sp.textContent = this.money(this.tierNet(v));
        if (si && v.featured_image && v.featured_image.src) si.src = v.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1');
      }
    }
    submit() {
      if (this.form && this.form.requestSubmit) this.form.requestSubmit();
      else if (this.form) this.form.querySelector('[type=submit]').click();
    }
  }
  function initWinwearProduct(scope) {
    (scope || document).querySelectorAll('[data-wwp]').forEach(function (el) {
      if (!el.dataset.wwpInit) { el.dataset.wwpInit = '1'; new WinwearProduct(el); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWinwearProduct(); });
  document.addEventListener('shopify:section:load', function (e) { initWinwearProduct(e.target); });

  } catch(e) { console.error(e); }
})();
})();
